// <head> metadata for JobsKeepMeInMindPage (https://www.dbos.dev/jobs/keep-me-in-mind).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: "Don't see an open position you'd like to fill? | DBOS",
    },
    {
      name: 'description',
      content:
        "Don't see an open role at DBOS? Send us your resume and tell us about your dream role, and we'll reach out if we start hiring for it.",
    },
    {
      property: 'og:title',
      content: "Don't see an open position you'd like to fill? | DBOS",
    },
    {
      property: 'og:description',
      content:
        "Don't see an open role at DBOS? Send us your resume and tell us about your dream role, and we'll reach out if we start hiring for it.",
    },
    {
      name: 'twitter:title',
      content: "Don't see an open position you'd like to fill? | DBOS",
    },
    {
      name: 'twitter:description',
      content:
        "Don't see an open role at DBOS? Send us your resume and tell us about your dream role, and we'll reach out if we start hiring for it.",
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/jobs/keep-me-in-mind',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
